import React from 'react';
import Header from './Header';
import background from './img/softwarePartners.png';
import MobileNavigation from './MobileNavigation';
import Footer from './Footer';
import Step1 from './img/Step1Emulator.webp';
import emulatorCreated from './img/terminalEmulatorCreated.png';
import Step2 from './img/Step2Emulator.webp';
import accessToken from './img/terminalAccessToken.png';
import terminalConnected from './img/terminalConnected.png';
import obtainAccessToken from './img/obtainAccessToken.png';
import requestProcessTransaction from './img/requestProcessTransaction.png';
import transactionCompleted from './img/transactionCompleted.png';
import transactionId from './img/transactionId.png';
const DeveloperSandbox = () => {
  return (
    <>
      <MobileNavigation />
      <section className="bg-[#212121]">
        <div
          className="w-full pb-28"
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: '200% 200%',
            backgroundPosition: 'bottom center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <Header />
          <div className="p-4 row md:p-8 how">
            <h3 className="text-white large">Sandbox Emulator Integration Guide</h3>
          </div>
          <div className="flex p-8 md:p-16 row flex-col justify-center gap-6 rounded-[28px] bg-white !mb-10 text-black [&_p]:text-black">
            <p className="light" style={{ textWrap: 'wrap', textWrapMode: 'auto' }}>
              This guide goes through the setup and flow for setting up the terminal emulator and
              rendering your first transaction. This guide assumes you have already created an
              instance of the emulator.
            </p>

            {/* STARTING TERMINAL */}
            <h2 className="text-black large">Starting the Terminal</h2>

            <p className="light" style={{ textWrap: 'wrap', textWrapMode: 'auto' }}>
              First in your iQ Pro Plus Gateway navigate to the Physical Terminals Page. Then select
              your instance of the Physical Terminal Emulator. Select <strong>Create New +</strong>{' '}
              at the top right.
            </p>

            <div className="my-6">
              <img src={Step1} alt="Step 1" />
            </div>

            <p className="light">
              This will display a menu that shows credentials tied to this terminal. Ensure that you
              have the Client ID and Secret for the Terminal Emulator you are using along with the
              Terminal ID. These will be used in the creation of the Terminals bearer token.
            </p>

            <div className="my-6">
              <img src={emulatorCreated} alt="Terminal Created Dialog" />
            </div>

            <p className="light">
              Select <strong>Launch Terminal</strong>. This will open a page that will serve as your
              terminal emulator.
            </p>

            <div className="my-6">
              <img src={Step2} alt="Step 2" />
            </div>

            {/* TERMINAL TOKEN */}
            <h2 className="text-black large">Obtaining the Terminal Access Token</h2>

            <p className="light" style={{ textWrap: 'wrap', textWrapMode: 'auto' }}>
              To obtain the bearer token for the emulator you will need the Client ID and Secret
              along with the Terminal ID. Make a bearer token API request ensuring the Terminal ID
              is included in the header.
            </p>

            <div className="my-6">
              <img src={accessToken} alt="Postman access token" />
            </div>

            <p className="light">
              Copy/paste the generated token into the Terminal Emulator and select
              <strong> Connect</strong>. If done correctly your terminal will be connected.
            </p>

            <div className="my-6">
              <img src={terminalConnected} alt="Terminal Connected" />
            </div>

            {/* TRANSACTION TOKEN */}
            <h2 className="text-black large">Obtaining the Access Token for Transactions</h2>

            <p className="light">
              Create an application in your gateway with the
              <strong> Integrator Gateway Standard </strong> role.
            </p>

            <p className="light">
              Use the application’s Client ID and Secret to generate an access token.
            </p>

            <p className="light">
              <strong>NOTE:</strong> This request does <strong>NOT</strong> include the Terminal ID
              in the header.
            </p>

            <div className="my-6">
              <img src={obtainAccessToken} alt="Obtain Access Token" />
            </div>

            {/* PAYMENT */}
            <h2 className="text-black large">Rendering Your First Transaction</h2>

            <p className="light">
              Using the bearer token you can send a payment intent request to the terminal.
            </p>

            <p className="light">
              View API documentation on the request URL and body{' '}
              <a
                href="https://api.basyspro.com/iqsaas/v1/scalar/#tag/terminal/POST/api/gateway/{gatewayId}/terminal/{terminalId}/command/payment-intent"
                target="_blank"
                rel="noreferrer"
                className="text-blue-500 underline"
              >
                here
              </a>
              .
            </p>

            <p className="light">
              Once submitted, the emulator will update indicating a pending transaction. Select{' '}
              <strong>Accept Process Transaction</strong> to process it.
            </p>

            <div className="my-4 callout">
              <p className="mb-0 text-black light">
                <strong>NOTE:</strong> You have 10 seconds to approve the transaction before the API
                request times out.
              </p>
            </div>

            <div className="my-6">
              <img src={requestProcessTransaction} alt="Request Process Transaction" />
            </div>

            <p className="light">
              Once accepted, the emulator will confirm completion and your API will return a
              transaction ID.
            </p>

            <div className="my-6">
              <img src={transactionCompleted} alt="Transaction Completed" />
            </div>

            <div className="my-6">
              <img src={transactionId} alt="Transaction ID" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default DeveloperSandbox;
